"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDecimalBasedOnCurrency = void 0;
const getDecimalBasedOnCurrency = (currencyCode) => {
    const zeroDecimalCurrencies = ["jpy", "inr", "vnd"];
    return zeroDecimalCurrencies.includes((currencyCode === null || currencyCode === void 0 ? void 0 : currencyCode.toLowerCase()) || "") ? 0 : 2;
};
exports.getDecimalBasedOnCurrency = getDecimalBasedOnCurrency;
